

let inject = [
    '$scope',
    'OrdersService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    'Pagination',
    'SessionService',
    '$window'
];

class PdfViewerController {
    constructor($scope, OrdersService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
        this.$state = $state;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.OrdersService = OrdersService;
        this.Pagination = Pagination;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
        this.$window = $window;
    }

    $onInit() {

    }

   
}

PdfViewerController.$inject = inject;

export default PdfViewerController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/pdf-viewer/pdf-viewer.controller.js
 **/